import { ExtraOptions, RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';
import {LoanApplicationLayoutComponent} from "@layout/loan-application-layout/loan-application-layout.component";
import {NbAuthComponent} from "@nebular/auth";
import {AdminLayoutComponent} from "@layout/admin-layout/admin-layout.component";
import {AppUserLayoutComponent} from "@layout/app-user-layout/app-user-layout.component";
import {IdrawLayoutComponentComponent} from "@layout/idraw-layout-component/idraw-layout-component.component";
import {IdrawWidgetLayoutComponent} from "./layout/idraw-widget-layout/idraw-widget-layout.component";


export const routes: Routes = [

  {
    path: '',
    component : LoanApplicationLayoutComponent,
    children: [
      {
        path: "",
        loadChildren: () =>
          import("./modules/loan-application/loan-application.module").
          then(
            m => m.LoanApplicationModule)
      }
    ]
  },
  {
    path: 'idraw',
    component : IdrawLayoutComponentComponent,
    children: [
      {
        path: "",
        loadChildren: () =>
          import("./modules/idraw/idraw.module").
          then(
            m => m.IdrawModule)
      }
    ]
  },
  {
    path: 'offer',
    component : IdrawLayoutComponentComponent,
    children: [
      {
        path: "",
        loadChildren: () =>
          import("./modules/offer/offer.module").
          then(
            m => m.OfferModule)
      }
    ]
  },
  {
    path: 'widget',
    component : IdrawWidgetLayoutComponent,
      children: [
      {
        path: "",
        loadChildren: () =>
          import("./modules/widget/widget.module").
          then(
            m => m.WidgetModule)
      }
    ]
  },
  {
    path: 'calculator',
    component : IdrawLayoutComponentComponent,
    children: [
      {
        path: "",
        loadChildren: () =>
          import("./modules/calculator/calculator.module").
          then(
            m => m.CalculatorModule)
      }
    ]
  },

  {
    path: 'auth',
    redirectTo: '/auth',
    pathMatch: 'full',
  },
  {
    path: 'auth',
    component: NbAuthComponent,
    loadChildren: () => import('@modules/auth/auth.module')
      .then(m => m.AuthModule),
  },
  {
    path: 'dashboard',
    component: AppUserLayoutComponent,
    loadChildren: () => import('@modules/dashboard/dashboard.module')
      .then(m => m.DashboardModule),
  },
  {
    path: 'admin',
    component: AdminLayoutComponent,
     loadChildren: () => import('@modules/admin/admin.module')
      .then(m => m.AdminModule),
  },

];

const config: ExtraOptions = {
  useHash: false,
};

@NgModule({
  imports: [RouterModule.forRoot(routes, config)],
  exports: [RouterModule],
})
export class AppRoutingModule {

}
